var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/ui/components/column.tsx";
const _excluded = ["heading", "icon", "children", "active"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import "core-js/modules/es.string.replace.js";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import Pullable from 'soapbox/components/pullable';
import { Column } from 'soapbox/components/ui';
import ColumnHeader from './column-header';

const UIColumn = _ref => {
  let {
    heading,
    icon,
    children,
    active
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  const columnHeaderId = heading && heading.replace(/ /g, '-');
  return /*#__PURE__*/React.createElement(Column, _extends({
    "aria-labelledby": columnHeaderId
  }, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 5
    }
  }), heading && /*#__PURE__*/React.createElement(ColumnHeader, {
    icon: icon,
    active: active,
    type: heading,
    columnHeaderId: columnHeaderId,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 19
    }
  }), /*#__PURE__*/React.createElement(Pullable, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 7
    }
  }, children));
};

export default UIColumn;